import React, { useState } from "react";
import { Fab } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import ClientActionsDialog from "../QuickActions/ClientActionsDialog";

interface Props {
  /** the policies shown (after the page's filters) - the ones offered */
  policies: MimshakData[];
  /** all the policies - offered after "הצג הכל" when filtered */
  allPolicies?: MimshakData[];
  onCreated?: () => void;
}

/** כפתור "פעולות" (כמו בעמוד ההפקדות בפורטל) – פותח את הפעולות המהירות ללקוח */
const PolicyActionsButton: React.FC<Props> = ({ policies, allPolicies, onCreated }) => {
  const [open, setOpen] = useState(false);

  if ((allPolicies ?? policies).length === 0) return null;

  return (
    <>
      <Fab variant="extended" color="primary" size="medium" onClick={() => setOpen(true)}>
        <BuildIcon sx={{ ml: 1 }} />
        פעולות
      </Fab>
      <ClientActionsDialog
        open={open}
        onClose={() => setOpen(false)}
        policies={policies}
        allPolicies={allPolicies}
        onCreated={onCreated}
      />
    </>
  );
};

export default PolicyActionsButton;
